import { ColumnShape } from 'react-base-table';
import { LogEntryEdge } from 'common/graphqlTypes';
import { PlaceholderLogEntryEdge } from 'hooks/useLRQ/useEventCache';
import { getTextWidth } from 'service/browser';
import cssVariables from 'styles/_export.module.scss';

const WIDTH = {
  MIN: 80,
  MAX: 800,
  DEFAULT: 220,
};
const BUFFER = 25;
const SAMPLE_SIZE = 100;

const estimateTextWidth = (text: string) => {
  const textWidth = getTextWidth(text, `${cssVariables.font_sm} ${cssVariables.monospaced_font}`) || 0;
  return Math.ceil(textWidth + BUFFER); // add buffer for safety
};

/**
 * Calculates column widths based on sample content data and sets(mutates) `column.width` property
 */
const autosizeColumns = (
  columns: ColumnShape<LogEntryEdge | PlaceholderLogEntryEdge>[],
  logEntryEdges: Array<LogEntryEdge | PlaceholderLogEntryEdge>,
) => {
  const sampleLogEntryEdges = logEntryEdges.filter((edge) => edge.logEntry).slice(-SAMPLE_SIZE);

  columns.forEach((column) => {
    if (column.width > 0) {
      return;
    }

    const fieldKey = column.title || '';
    let fieldWidth = estimateTextWidth(fieldKey);

    // Estimate width
    sampleLogEntryEdges.forEach((sampleLogEntryEdge) => {
      const field = column.field;
      const content = sampleLogEntryEdge.logEntry?.values?.[field] || sampleLogEntryEdge.logEntry?.serverInfo?.[field];
      if (content) {
        fieldWidth = Math.max(fieldWidth, estimateTextWidth(content));
      }
    });

    // Set width
    column.width = Math.min(fieldWidth, WIDTH.MAX); // not wider than MAX
    column.width = Math.max(column.width, WIDTH.MIN); // not narrower than MIN
    if (Number.isNaN(column.width)) {
      column.width = WIDTH.DEFAULT;
    }
  });

  return columns;
};

export default autosizeColumns;
